module.exports = __webpack_public_path__ + "static/img/132_TO8_1823_og.dd809b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/132_TO8_1823_og.jpg
// module id = VeoV
// module chunks = 0